<style scoped>
    .led-grey{
    margin: 0 auto;
    width: 0.7rem;
    height: 0.7rem;
    background-color: grey;
    border-radius: 50%;   
    }

    .led-green {
    margin: 0 auto;
    width: 0.7rem;
    height: 0.7rem;
    background-color: #ABFF00;
    border-radius: 50%;
    box-shadow:  inset #304701 0 -1px 9px, #89FF00 0 1px 1px;
    }

    .led-red {
    margin: 0 auto;
    width: 0.7rem;
    height: 0.7rem;
    background-color: red;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #304701 0 -1px 9px, red 0 1px 1px;
    }

    .led-yellow-no-blink {
    margin: 0 auto;
    
    width: 0.7rem;
    height: 0.7rem;
    background-color: #FF0;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #808002 0 -1px 9px, #FF0 0 1px 1px;
    }

    .led-yellow {
    margin: 0 auto;
    
    width: 0.7rem;
    height: 0.7rem;
    background-color: #FF0;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #808002 0 -1px 9px, #FF0 0 1px 1px;
    -webkit-animation: blinkYellow 1s infinite;
    -moz-animation: blinkYellow 1s infinite;
    -ms-animation: blinkYellow 1s infinite;
    -o-animation: blinkYellow 1s infinite;
    animation: blinkYellow 1s infinite;
    }
    .led-blue {
    margin: 0 auto;
    width: 0.7rem;
    height: 0.7rem;
    background-color: #24E0FF;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #006 0 -1px 2px, #3F8CFF 0 2px 12px;
    -webkit-animation: blueYellow 1s infinite;
    -moz-animation: blueYellow 1s infinite;
    -ms-animation: blueYellow 1s infinite;
    -o-animation: blueYellow 1s infinite;
    animation: blueYellow 1s infinite;
    }


    @-webkit-keyframes blueYellow {
        from { background-color: #3F8CFF; }
        50% { background-color: rgb(160, 223, 252); box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #006 0 -1px 9px, rgb(123, 174, 250) 0 2px 0; }
        to { background-color: #3F8CFF; }
    }
    @-moz-keyframes blueYellow {
        from { background-color: #3F8CFF; }
        50% { background-color: rgb(160, 223, 252);box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #006 0 -1px 9px, rgb(123, 174, 250) 0 2px 0; }
        to { background-color: #3F8CFF; }
    }
    @-ms-keyframes blueYellow {
        from { background-color: #3F8CFF; }
        50% { background-color: rgb(160, 223, 252); box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #006 0 -1px 9px, rgb(123, 174, 250) 0 2px 0; }
        to { background-color: #3F8CFF; }
    }
    @-o-keyframes blueYellow {
        from { background-color: #3F8CFF; }
        50% { background-color: rgb(160, 223, 252);box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #006 0 -1px 9px, rgb(123, 174, 250) 0 2px 0; }
        to { background-color: #3F8CFF; }
    }
    @keyframes blueYellow {
        from { background-color: #3F8CFF; }
        50% { background-color: rgb(160, 223, 252); box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 3px 1px, inset #006 0 -1px 9px, rgb(123, 174, 250) 0 2px 0; }
        to { background-color: #3F8CFF; }
    }



    @-webkit-keyframes blinkYellow {
        from { background-color: #FF0; }
        50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
        to { background-color: #FF0; }
    }
    @-moz-keyframes blinkYellow {
        from { background-color: #FF0; }
        50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
        to { background-color: #FF0; }
    }
    @-ms-keyframes blinkYellow {
        from { background-color: #FF0; }
        50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
        to { background-color: #FF0; }
    }
    @-o-keyframes blinkYellow {
        from { background-color: #FF0; }
        50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
        to { background-color: #FF0; }
    }
    @keyframes blinkYellow {
        from { background-color: #FF0; }
        50% { background-color: #AA0; box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #808002 0 -1px 9px, #FF0 0 2px 0; }
        to { background-color: #FF0; }
    }
</style>

<template>
<div>
    <v-avatar :size="12" v-bind:class="classObj"><v-icon></v-icon></v-avatar>   
    <span v-if="label" style="margin-left:0.5rem">{{label}}</span> 
</div>
</template>

<script>
export default {
    name:"Led",
    props:{
        "classObj": Object,
        "label":String
    }
}
</script>

